module.exports = __webpack_public_path__ + "fonts/Roboto-Light3c37aa69cd77e6a53a067170fa8fe2e9.woff2]";